import { useConfirmationModalContext } from 'Context/ConfirmationModalContext';

export const useConfirmationModal = (payload) => useConfirmationModalContext(payload);
